import { useMutation } from '@tanstack/react-query';
import { http } from '@/lib/http';

/** `{ "<userId>": "<IANA tz>", ... }` */
export type TimezoneUsersPayload = Record<string, string>;

interface BulkUpdateResult {
  errors?: string[];
}

async function updateTimezones(
  users: TimezoneUsersPayload
): Promise<BulkUpdateResult | undefined> {
  return http.patch('users/update_timezones', { users }) as Promise<
    BulkUpdateResult | undefined
  >;
}

export function useUpdateInterviewerTimezones() {
  return useMutation({ mutationFn: updateTimezones });
}
